import type { NavItem, SiteConfig } from '@/types'

export const siteConfig: SiteConfig = {
    name: 'Himelio',
    legalName: 'Himelio',
    description: 'Himelio es la plataforma web de facturación comercial, punto de venta, inventario, clientes y Asistente fiscal DGII 607 para negocios de República Dominicana. Prueba el Plan Pro 14 días gratis.',
    url: 'https://himelio.com',
    ogImage: '/images/himelio/shop-counter.jpg',
    email: 'servicios@himelio.com',
    phone: '',
    phoneHref: '',
    address: 'República Dominicana',
    socials: []
}

export const TAGLINE = 'Facturación clara, rápida y en control total.'

/** The Himelio app lives on its own address. Change it here and every sign up and sign in link follows. */
export const APP_URL = 'https://himelio.com'

export const SIGNUP_HREF = `${APP_URL}/auth/sign-up`

export const LOGIN_HREF = `${APP_URL}/auth/sign-in`

export const mainNav: Array<NavItem> = [
    { label: 'Funciones', href: '/funciones' },
    { label: 'Planes', href: '/pricing' },
    { label: 'Documentación', href: '/docs' },
    { label: 'Ayuda', href: '/help' },
    { label: 'Instalar', href: '/instalar' },
    { label: 'Nosotros', href: '/about' },
    { label: 'Contacto', href: '/servicios' }
]

export const mobileNav: Array<NavItem> = [
    { label: 'Inicio', href: '/' },
    ...mainNav
]

export const footerProduct: Array<NavItem> = [
    { label: 'Inicio', href: '/' },
    { label: 'Funciones', href: '/funciones' },
    { label: 'Planes y precios', href: '/pricing' },
    { label: 'Instalar Himelio', href: '/instalar' },
    { label: 'Seguridad', href: '/security' }
]

export const footerResources: Array<NavItem> = [
    { label: 'Documentación', href: '/docs' },
    { label: 'Guía Asistente DGII 607', href: '/docs/fiscal-607' },
    { label: 'Centro de ayuda', href: '/help' },
    { label: 'Preguntas frecuentes', href: '/help#preguntas' }
]

export const footerCompany: Array<NavItem> = [
    { label: 'Acerca de Himelio', href: '/about' },
    { label: 'Contacto y soporte', href: '/servicios' },
    { label: 'Privacidad', href: '/privacy' },
    { label: 'Términos del servicio', href: '/terms' }
]

export const CONTACT_HREF = '/servicios'

export const START_HREF = SIGNUP_HREF

export const START_LABEL = 'Probar 14 días gratis'

/** Shown wherever the DGII 607 assistant is described. Himelio prepares the files, the user files them. */
export const DGII_NOTICE = 'Himelio no cuenta con certificación en la DGII ni transmite e-CF por webservice. El asistente prepara tus archivos y tú los presentas en la Oficina Virtual (OFV).'
